import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.action-reasons')
  .service('ActionReasonsAPI', ActionReasonsAPI);

function ActionReasonsAPI(): BringozApi {
  return {
    base: `/actionReason`,
    infiniteScroll: {
      address: `/actionReason`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      createActionReason: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      updateActionReason: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteActionReason: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
    }
  }
}
